export default __webpack_public_path__ + "static/media/ZZC_7767.5059b748.jpg";